import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import React, { FC, useState } from "react";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss, { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface CENRecentQuotesCardListStyles {
    container?: InjectableCss;
}

export const cenRecentQuotesCardListStyles: CENRecentQuotesCardListStyles = {
    container: {
        css: css`
            padding: 0px 24px 0px 24px;
            /* border: 4px solid #f2f2f2; */
            border-top: none !important;
            overflow-y: scroll;
            max-height: 384px;
            ::-webkit-scrollbar {
                width: 6px; /* Width of the vertical scrollbar */
                height: 6px; /* Height of the horizontal scrollbar */
            }

            ::-webkit-scrollbar-track {
                background: #ffffff; /* Background of the scrollbar track */
                border-radius: 3px; /* Rounded corners for the track */
            }

            ::-webkit-scrollbar-thumb {
                background: #e0dfe0; /* Color of the scrollbar thumb */
                border-radius: 3px; /* Rounded corners for the thumb */
            }

            ::-webkit-scrollbar-thumb:hover {
                background: #555; /* Color of the thumb on hover */
            }
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        padding-left: 8px;
                        padding-right: 8px;
                    `,
                    css`
                        padding-left: 16px;
                        padding-right: 16px;
                    `,
                    css``,
                    css``,
                ]);
            }}
        `,
    },
};

interface CENRecentQuotesCardListProps {
    extendedStyles?: CENRecentQuotesCardListStyles;
    css?: StyledProp;
    children?: React.ReactNode;
}

const CENRecentQuotesCardList: FC<CENRecentQuotesCardListProps> = ({ extendedStyles, children, ...otherProps }) => {
    const [styles] = useState(() => mergeToNew(cenRecentQuotesCardListStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.container} {...otherProps}>
            {children}
        </StyledWrapper>
    );
};

export default CENRecentQuotesCardList;
